import React from 'react';
import PropTypes from 'prop-types';

// Components
import InfoPanel from './InfoPanel';
import AlertUpdateWidget from './AlertUpdateWidget';
import LineItem from './LineItem';
import InfoDialog from './InfoDialog';

import { DateTime } from 'luxon';

import { isNull } from '../constants';
import { T, FONT_MONO, INDICATOR_TEXT } from '../constants/tokens';

// Icons
import Hallway from '../images/customIcons/Hallway.png';
import Room from '../images/customIcons/Room.png';
import Door from '../images/customIcons/Door.png';

function getIcon(hubType) {
  switch (hubType) {
    case 'Hallway':
      return Hallway;
    case 'Room':
      return Room;
    case 'Door':
      return Door;
    default:
      return;
  }
}

const HEADER = (hub) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      <img
        src={getIcon(hub.getHubType())}
        alt=''
        style={{ width: 32, height: 32, flex: 'none', objectFit: 'contain' }}
      />
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            fontFamily: FONT_MONO,
            fontSize: 20,
            fontWeight: 500,
            lineHeight: '28px',
            color: T.ink,
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }}
        >
          {hub.getSerialNumber()}
        </div>
        <div
          style={{
            fontFamily: FONT_MONO,
            fontSize: 12,
            fontWeight: 500,
            lineHeight: '16px',
            textTransform: 'uppercase',
            color: T.muted
          }}
        >
          {hub.getHubType()} hub
        </div>
      </div>
    </div>
  );
};

const CHILDREN = (hub) => {
  const connected = hub.getIsConnected();
  const lastSeen = hub.getLastSeenTimestamp();

  return (
    <>
      <LineItem description='Hub type' value={hub.getHubType()} />
      <LineItem description='Room identifier' value={hub.getRoom()?.getIdentifier()} />
      <LineItem
        description='Connection'
        value={connected ? 'Connected' : 'Not connected'}
        tone={connected ? null : INDICATOR_TEXT.error}
      />
      <LineItem description='Firmware' value={hub.getFirmwareVersion() && 'v' + hub.getFirmwareVersion()} mono />
      <LineItem
        description='Last seen'
        value={lastSeen ? lastSeen.toLocaleString(DateTime.DATETIME_SHORT) : null}
        mono
      />
      <LineItem description='Notes' value={hub.getNotes()} last />

      <AlertUpdateWidget updates={hub.getAlertUpdates()} />
    </>
  );
};

export default function HubInfoPanel({ hub, handleClose, isMobile }) {
  const statusColor = hub?.getRoom()?.getAlertStatus()?.getColor()?.main;

  return isMobile ? (
    <InfoDialog
      statusColor={statusColor}
      header={HEADER(hub)}
      handleClose={handleClose}
      open={!isNull(hub)}
    >
      {CHILDREN(hub)}
    </InfoDialog>
  ) : (
    <InfoPanel
      statusColor={statusColor}
      header={HEADER(hub)}
    >
      {CHILDREN(hub)}
    </InfoPanel>
  );
}

HubInfoPanel.propTypes = {
  hub: PropTypes.object,
  handleClose: PropTypes.func,
  isMobile: PropTypes.bool
};
